{
  "msg": {
    "hello": "Hello World!",
    "test": "%{msg} message!"
  },
  "button": {
    "save": {
      "title": "Save",
      "tooltip": {
        "h": "Save",
        "t": "You can save your data."
      }
    },
    "reset": {
      "title": "Reset",
      "tooltip": {
        "h": "Reset",
        "t": "You can reset your input."
      }
    },
    "cancel": {
      "title": "Cancel",
      "tooltip": {
        "h": "Cancel",
        "t": "You can cancel the process."
      }
    },
    "add": "Neu",
    "update": {
      "title": "Update",
      "tooltip": {
        "h": "Update",
        "t": "You can update the data."
      }
    },
    "back": {
      "title": "Back",
      "tooltip": {
        "h": "Back",
        "t": "You can go back to the overview."
      }
    }
  },
  "navigation": {
    "account": {
      "title": "Account",
      "tooltip": {
        "h": "Account management",
        "t": "You can manage your account."
      }
    },
    "locations": {
      "title": "Locations",
      "tooltip": {
        "h": "Locations",
        "t": "Overview about locations etc"
      }
    },
    "users": {
      "title": "Users",
      "tooltip": {
        "h": "User administration",
        "t": "Overviews of all users"
      }
    },
    "invitations": {
      "title": "Invitations",
      "tooltip": {
        "h": "Invitations",
        "t": "Overview of all running invitations"
      }
    },
    "ui": {
      "title": "UI-UX",
      "tooltip": {
        "h": "UI-UX",
        "t": "Overview and examples of all components from LxVue3"
      }
    },
    "performance": {
      "title": "Perform.",
      "tooltip": {
        "h": "Performance Test",
        "t": "Test with massiv use of form fields"
      }
    },
    "mode": {
      "title": "mode",
      "tooltip": {
        "h": "Select Mode",
        "t": "Selection of brightness, color, layout, language"
      }
    }
  },
  "subnavigation": {
    "account": "Manage account",
    "subtitleAccount": "You can change your account data",
    "organization": "Change organization",
    "subtitleOrganization": "Change the currently selected organization",
    "imprint": "Imprint",
    "subtitleImprint": "On the subject DSGVO",
    "lock": "Lock",
    "subtitleLock": "If you only want to leave the site for a short time",
    "logout": "Logout",
    "subtitleLogout": "Please always log out properly"
  },
  "validation": {
    "required": "The field {name} must be filled out."
  },
  "locationTypes": {
    "clinic": "Hospital",
    "pharmacy": "Pharmacy",
    "company": "Super duper Company"
  },
  "locationList": {
    "button": {
      "locationNew": {
        "title": "New",
        "tooltip": {
          "h": "Create new",
          "t": "You can create a new location."
        }
      }
    },
    "tableLocation": {
      "header": {
        "name": "Location name",
        "address": "Address",
        "isActive": "Activity",
        "locationType": "Type",
        "support": "Support"
      },
      "renderer": {
        "delete": "Delete",
        "address": "Address",
        "line1": "Line 1",
        "line2": "Line 2",
        "zip": "Zip",
        "city": "City",
        "support": "Support",
        "email": "Email",
        "phone": "Phone",
        "isActive": "Activity"
      }
    },
    "filter": {
    }
  },
  "locationDetails": {
    "expansionPanel": {
      "locationData": {
        "header": "Location Data",
        "subheader": "Display of general location data"
      },
      "locationAdmins": {
        "header": "Location Administrators",
        "subheader": "Invite new users as an administrator or manage existing ones"
      },
      "supportData": {
        "header": "Support Data",
        "subheader": "Display of general support data"
      }
    },
    "select": {
      "title": "Type of Institution",
      "placeholder": "Please specify the kind of institution."
    },
    "input": {
      "name": {
        "title": "Location Name",
        "placeholder": "Please enter the location name."
      },
      "line1": {
        "title": "Address Line 1",
        "placeholder": "Information about the location like street, number, postal code"
      },
      "line2": {
        "title": "Address Line 2",
        "placeholder": "Additional information"
      },
      "zip": {
        "title": "ZIP Code",
        "placeholder": "ZIP Code"
      },
      "city": {
        "title": "City",
        "placeholder": "City"
      },
      "email": {
        "title": "Email",
        "placeholder": "Please enter a valid email address."
      },
      "supportEmail": {
        "title": "Support Email",
        "placeholder": "Support email for important questions"
      },
      "supportPhone": {
        "title": "Support Phone",
        "placeholder": "Support phone for important questions"
      }
    }
  }
}


